// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Pe_A","selected":"Chip_selected__33Fy3"};